import { Formik } from 'formik';
import styled from 'styled-components';
import { object, string } from 'yup';
import { StyledFormField } from '@/components/uielements/form-fields/styles';
import { Form, Input } from '@/components/uielements/formik';
import { StyledPrimaryButton } from '@/components/uielements/primaryButton/styles';
import { LAYOUT } from '@/constants/styles';
import { REGEX, REGEX_VALIDATION_STRINGS, VALIDATION_STRINGS } from '@/constants/validation';

const phoneCaptureSchema = object({
  // The phone must be present, at least 10 digits, and valid.
  phone: string()
    .required(VALIDATION_STRINGS.REQUIRED)
    .min(10, VALIDATION_STRINGS.PHONE)
    .matches(REGEX.PHONE, REGEX_VALIDATION_STRINGS.PHONE),
});

/**
 * When users create accounts outside of Koala they don't always provide a phone number
 * in those cases we need ask the user for their phone number to complete their account
 */
export function PhoneCaptureForm({ onPhoneCapture }: { onPhoneCapture: (phone: string) => void }) {
  return (
    <Formik
      validateOnBlur
      validateOnChange={false}
      onSubmit={({ phone }, { resetForm }) => {
        onPhoneCapture(phone);
        resetForm();
      }}
      initialValues={{ phone: '' }}
      validationSchema={phoneCaptureSchema}
    >
      {() => (
        <Form>
          <StyledFormField>
            <Input id="phone" name="phone" type="tel" label="Phone Number" autoFocus />
          </StyledFormField>
          <SubmitButton type="submit">Continue</SubmitButton>
        </Form>
      )}
    </Formik>
  );
}

const SubmitButton = styled(StyledPrimaryButton)`
  margin-left: ${LAYOUT.GUTTER}px;
  @media (max-width: 767px) {
    margin: 0 auto;
  }
`;
